var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-zone"},[_c('div',{},[_vm._v(_vm._s(_vm.verboseName))]),_vm._v(" "),_c('el-input',{staticClass:"viveco-input",attrs:{"type":"textarea","rows":_vm.rows,"disabled":_vm.disabled},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9a91fe4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/report/pdfDescriptorInput.vue
// module id = null
// module chunks = 